import * as THREE from "three";

export default function(x, y, z, size, textureLoader) {
  Object.setPrototypeOf(this, new THREE.Object3D());
  this.position.set(x, y, z);
  this.name = "Board";

  const texture = textureLoader.load("/img/3DTextures/memoram/game/board.jpg");

  const geometry = new THREE.BoxBufferGeometry(size, size, 0.0125);
  const material = new THREE.MeshPhongMaterial({ map: texture });

  const mesh = new THREE.Mesh(geometry, material);

  this.add(mesh);
}
